'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = require('preact');

var _preact2 = require('unistore/preact');

var _preactFela = require('preact-fela');

var _actions = require('../../actions');

var _keyframes = require('../../styles/keyframes');

var _Navbar = require('../Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _HeaderProfile = require('./HeaderProfile');

var _HeaderProfile2 = _interopRequireDefault(_HeaderProfile);

var _HeaderMenu = require('./HeaderMenu');

var _HeaderMenu2 = _interopRequireDefault(_HeaderMenu);

var _HeaderBrand = require('./HeaderBrand');

var _HeaderBrand2 = _interopRequireDefault(_HeaderBrand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules(_ref) {
  var inScroll = _ref.inScroll,
      menus = _ref.menus,
      theme = _ref.theme,
      loggedIn = _ref.loggedIn;

  var background = inScroll ? theme.backgroundInScroll : theme.gradient == 'true' ? theme.gradientColor : theme.background;
  background = background || theme.background || theme.color;
  var hasMenus = menus.length;
  return {
    header: {
      height: '48px',
      background: background,
      desktop: {
        minHeight: inScroll ? 'auto' : hasMenus ? '109px' : '68px',
        height: inScroll ? '56px' : undefined
      }
    },
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: !inScroll || loggedIn ? 'center' : 'space-between',

      desktop: {
        position: 'relative',
        boxSizing: 'border-box',
        justifyContent: 'space-between',
        maxWidth: theme.full ? '100%' : '1170px',
        padding: '0 15px 0 0',
        margin: 'auto',
        height: inScroll ? '100%' : '68px'
      }
    }
  };
};

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.mobile === false && props.heimdall.dropdown.menu) {
        this.props.handleOpenMenu('menu');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          mobile = _props.mobile,
          inScroll = _props.inScroll,
          loggedIn = _props.loggedIn,
          product = _props.product,
          brand = _props.brand,
          config = _props.config,
          heimdall = _props.heimdall,
          styles = _props.styles;

      var defaultProps = { mobile: mobile, inScroll: inScroll, loggedIn: loggedIn, config: config };

      return (0, _preact.h)(
        'header',
        { className: styles.header },
        (0, _preact.h)(
          'div',
          { className: styles.container },
          (0, _preact.h)(_HeaderMenu2.default, _extends({}, defaultProps, { onOpenMenu: this.props.handleOpenMenu })),
          (0, _preact.h)(_HeaderBrand2.default, _extends({}, defaultProps, { brand: brand, product: product, heimdall: heimdall })),
          (0, _preact.h)(_Navbar2.default, _extends({}, defaultProps, { goMenu: this.props.goMenu })),
          (0, _preact.h)(_HeaderProfile2.default, defaultProps)
        )
      );
    }
  }]);

  return Header;
}(_preact.Component);

exports.default = (0, _preact2.connect)('product,loggedIn,menus,brand,config,heimdall', {
  handleOpenMenu: function handleOpenMenu(menu) {
    return (0, _actions.toggleMenuDropdown)(menu);
  },
  goMenu: _actions.goMenu
})((0, _preactFela.connect)(rules)(Header));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/Header.js
// module id = 184
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38